import "@fontsource/poppins";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
// import "ag-grid-community/styles/ag-grid.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
// import "./style/components-style/Grid.css";
// import "react-resizable/css/styles.css";
// import "./style/pages-style/Login.css";
import { Box } from "@mui/material";
import { Suspense, useEffect } from "react";
import TagManager from "react-gtm-module";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import Header from "./app_components/Header";
import Footer from "./app_components/Footer";
import RightSidebar from "./app_components/RightSidebar";
import SideBar from "./app_components/SideBar";
import { AuthProvider } from "./authentication/AuthProvider";
import { PendingUserProvider } from "./authentication/PendingUserContext";
import PrivateRoute from "./authentication/PrivateRoute";
import LocalLoading from "./components/dialog/LocalLoading";
import { ContextProvider } from "./components/page-context/ContextProvider";
import "./components/translation/i18n";
import ImpersonationBanner from "./components/banner/ImpersonationBanner";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import B2B_Directory_Dashboard from "./pages/B2B_Directory/B2B_Directory_Dashboard";
import BuildingArchive from "./pages/Building/BuildingArchive";
import BuildingCircularity from "./pages/Building/BuildingCircularity";
import BuildingComparison from "./pages/Building/BuildingComparison";
import BuildingDashboard from "./pages/Building/BuildingDashboard";
import BuildingDPP_Edit from "./pages/Building/DPP/BuildingDPP_Edit";
import BuildingPreBuiltTemplate from "./pages/Building/BuildingPreBuiltTemplate";
import BuildingWorkspace from "./pages/Building/BuildingWorkspace";
import LEEDTab from "./pages/Building/tabs/LEEDTab";
import NetZeroTab from "./pages/Building/tabs/NetZeroTab";
import Client_Directory_Comparison from "./pages/Client_Directory/Client_Directory_Comparison";
import Client_Directory_Dashboard from "./pages/Client_Directory/Client_Directory_Dashboard";
import Client_Directory_My_Submissions from "./pages/Client_Directory/Client_Directory_MySubmissions";
import Client_Directory_Reports from "./pages/Client_Directory/Client_Directory_Reports";
import PendingResponses from "./pages/Client_Directory/PendingResponses";
import Client_Directory_SubmitData from "./pages/Client_Directory/Client_Directory_SubmitData";
import CollaborateDashboard from "./pages/Collaborate/CollaborateDashboard";
import CollaborateDigitalDataSharing from "./pages/Collaborate/CollaborateDigitalDataSharing";
import CollaborateExternal from "./pages/Collaborate/CollaborateExternal";
import CollaborateSharedLibrary from "./pages/Collaborate/CollaborateHistory";
import CollaborateInternal from "./pages/Collaborate/CollaborateInternal";
import CollaborateMySpace from "./pages/Collaborate/CollaborateMySpace";
import CollaborateSharedDataHistory from "./pages/Collaborate/CollaborateSharedDataHistory";
import CollaboratePartnership from "./pages/Collaborate/CollaboratePartnership";
import ComplianceCDP from "./pages/Compliance/ComplianceCDP";
import ComplianceEcoVadis from "./pages/Compliance/ComplianceEcoVadis";
import ComplianceLEED from "./pages/Compliance/ComplianceLEED";
import ComplianceSBTI from "./pages/Compliance/ComplianceSBTI";
import DPP_Dashboard from "./pages/Digital_Product_Passport/DPP_Dashboard";
import DPP_Edit_Pending from "./pages/Digital_Product_Passport/DPP_Edit_Pending";
import DPP_History from "./pages/Digital_Product_Passport/DPP_History";
import DPP_Stats from "./pages/Digital_Product_Passport/DPP_Stats";
import DPP_View_Pending from "./pages/Digital_Product_Passport/DPP_View_Pending";
import DPP_View_Published from "./pages/Digital_Product_Passport/DPP_View_Published";
import EngagementDashboard from "./pages/Engagement/EngagementDashboard";
import EngagementSideBar from "./pages/Engagement/EngagementSideBar";
import HomePage from "./pages/HomePage";
import LandingPage from "./pages/LandingPage";
import Archive from "./pages/Library/Archive/Archive";
import EPD from "./pages/Library/EPD/EPD";
import PrebuiltTemplatePage from "./pages/Library/PrebuiltTemplate/PrebuiltTemplatePage";
import Login from "./pages/Login/Login";
import Logout from "./pages/Login/Logout";
import NotificationDashboard from "./pages/Notification/NotificationDashboard";
import CorporateComparison from "./pages/Organization/Corporate/CorporateComparison";
import CorporateDashboard from "./pages/Organization/Corporate/CorporateDashboard";
import OrganizationDashboard from "./pages/Organization/OrganizationDashboard";
import OrganizationSideBar from "./pages/Organization/OrganizationSideBar";
import StructureComparison from "./pages/Organization/Structure/StructureComparison";
import StructureDashboard from "./pages/Organization/Structure/StructureDashboard";
import StructureWorkspace from "./pages/Organization/Structure/StructureWorkspace";
import SupplyChainComparison from "./pages/Organization/SupplyChain/SupplyChainComparison";
import SupplyChainDashboard from "./pages/Organization/SupplyChain/SupplyChainDashboard";
import SupplyChainWorkspace from "./pages/Organization/SupplyChain/SupplyChainWorkspace";
import ProductDPP_Edit from "./pages/Products/DPP/ProductDPP_Edit";
import ProjectDPP_Edit from "./pages/Projects/DPP/ProjectDPP_Edit";
import ProductArchive from "./pages/Products/ProductArchive";
import ProductCircularity from "./pages/Products/ProductCircularity";
import ProductCollaborate from "./pages/Products/ProductCollaborate";
import ProductComparison from "./pages/Products/ProductComparison";
import ProductDashboard from "./pages/Products/ProductDashboard";
import ProductEpdDppLibrary from "./pages/Products/ProductEpdDppLibrary";
import ProductPreBuiltTemplate from "./pages/Products/ProductPreBuiltTemplate";
import ProductReuseWorkspace from "./pages/Products/ProductReuseWorkspace";
import ProductWorkspace from "./pages/Products/ProductWorkspace";
import ProductSupplierPortal from "./pages/Products/ProductSupplierPortal";
import ProfileDashboard from "./pages/Profile/ProfileDashboard";
import UserAccountSettings from "./pages/Profile/UserAccountSettings";
import ProjectArchive from "./pages/Projects/ProjectArchive";
import ProjectCircularity from "./pages/Projects/ProjectCircularity";
import ProjectComparison from "./pages/Projects/ProjectComparison";
import ProjectDashboard from "./pages/Projects/ProjectDashboard";
import ProjectPreBuiltTemplate from "./pages/Projects/ProjectPreBuiltTemplate";
import ProjectWorkspace from "./pages/Projects/ProjectWorkspace";
import ProjectSupplierPortal from "./pages/Projects/ProjectSupplierPortal";
import Register from "./pages/Register";
import SectorDashboard from "./pages/Sector/SectorDashboard";
import SectorSideBar from "./pages/Sector/SectorSideBar";
import SettingDashboard from "./pages/Setting/SettingDashboard";
import Supplier_Directory_Comparison from "./pages/Supplier_Directory/Supplier_Directory_Comparison";
import Supplier_Directory_Dashboard from "./pages/Supplier_Directory/Supplier_Directory_Dashboard";
import Supplier_Directory_My_Submissions from "./pages/Supplier_Directory/Supplier_Directory_MySubmissions";
import Supplier_Directory_Reports from "./pages/Supplier_Directory/Supplier_Directory_Reports";
import Supplier_Directory_SubmitData from "./pages/Supplier_Directory/Supplier_Directory_SubmitData";
import SupportDashboard from "./pages/Support/SupportDashboard";
import NetZero from "./pages/Sustainability/NetZero/NetZero";
import TermsAndConditions from "./pages/TermsAndConditions";
import UsageDashboard from "./pages/Usage/UsageDashboard";
import routing from "./routing";
import "./style/App.css";
import "./style/components-style/ProcessTable.css";
import "./style/components-style/Table.css";
import ThemeProviderWrapper from "./theme/ThemeProviderWrapper";
import QueryProvider from "./utilities/QueryProvider";
import ScrollToTop from "./components/utils/ScrollToTop";
import ArivuBot from "./app_components/ArivuBot/ArivuBot";

// const FleetPerformance = lazy(() => import("./fleet-pages/FleetPerformance"));
// const OrganizationalComparison = lazy(() => import("./organizational-pages/OrganizationalComparison"));
// const OrganizationalSupplyChain = lazy(() => import("./organizational-pages/OrganizationalSupplyChain"));
// const AdminDashboard = lazy(() => import("./pages/Admin/AdminDashboard"));
// const BuildingArchive = lazy(() => import("./pages/Building/BuildingArchive"));
// const BuildingCircularity = lazy(() => import("./pages/Building/BuildingCircularity"));
// const BuildingDashboard = lazy(() => import("./pages/Building/BuildingDashboard"));
// const BuildingPreBuiltTemplate = lazy(() => import("./pages/Building/BuildingPreBuiltTemplate"));
// const BuildingWorkspace = lazy(() => import("./pages/Building/BuildingWorkspace"));
// const LEEDTab = lazy(() => import("./pages/Building/tabs/LEEDTab"));
// const NetZeroTab = lazy(() => import("./pages/Building/tabs/NetZeroTab"));
// const CollaborateDashboard = lazy(() => import("./pages/Collaborate/CollaborateDashboard"));
// const CollaborateDigitalDataSharing = lazy(() => import("./pages/Collaborate/CollaborateDigitalDataSharing"));
// const CollaborateExternal = lazy(() => import("./pages/Collaborate/CollaborateExternal"));
// const CollaborateSharedLibrary = lazy(() => import("./pages/Collaborate/CollaborateHistory"));
// const CollaborateInternal = lazy(() => import("./pages/Collaborate/CollaborateInternal"));
// const CollaborateMySpace = lazy(() => import("./pages/Collaborate/CollaborateMySpace"));
// const CollaborateSharedDataHistory = lazy(() => import("./pages/Collaborate/CollaborateSharedDataHistory"));
// const ComplianceCDP = lazy(() => import("./pages/Compliance/ComplianceCDP"));
// const ComplianceEcoVadis = lazy(() => import("./pages/Compliance/ComplianceEcoVadis"));
// const ComplianceLEED = lazy(() => import("./pages/Compliance/ComplianceLEED"));
// const ComplianceSBTI = lazy(() => import("./pages/Compliance/ComplianceSBTI"));
// const DPP_Dashboard = lazy(() => import("./pages/Digital_Product_Passport/DPP_Dashboard"));
// const DPP_Edit_Pending = lazy(() => import("./pages/Digital_Product_Passport/DPP_Edit_Pending"));
// const DPP_History = lazy(() => import("./pages/Digital_Product_Passport/DPP_History"));
// const DPP_Stats = lazy(() => import("./pages/Digital_Product_Passport/DPP_Stats"));
// const DPP_View_Pending = lazy(() => import("./pages/Digital_Product_Passport/DPP_View_Pending"));
// const DPP_View_Published = lazy(() => import("./pages/Digital_Product_Passport/DPP_View_Published"));
// const EngagementDashboard = lazy(() => import("./pages/Engagement/EngagementDashboard"));
// const EngagementSideBar = lazy(() => import("./pages/Engagement/EngagementSideBar"));
// const HomePage = lazy(() => import("./pages/HomePage"));
// const HomeViewType = lazy(() => import("./pages/HomeViewType"));
// const Library = lazy(() => import("./pages/Library"));
// const Login = lazy(() => import("./pages/Login/Login"));
// const Logout = lazy(() => import("./pages/Login/Logout"));
// const NetZero = lazy(() => import("./pages/NetZero"));
// const NotificationDashboard = lazy(() => import("./pages/Notification/NotificationDashboard"));
// const CorporateDashboard = lazy(() => import("./pages/Organization/Corporate/CorporateDashboard"));
// const OrganizationDashboard = lazy(() => import("./pages/Organization/OrganizationDashboard"));
// const OrganizationSideBar = lazy(() => import("./pages/Organization/OrganizationSideBar"));
// const StructureDashboard = lazy(() => import("./pages/Organization/Structure/StructureDashboard"));
// const SupplyChainDashboard = lazy(() => import("./pages/Organization/SupplyChain/SupplyChainDashboard"));
// const ProductDPP_Edit = lazy(() => import("./pages/Products/DPP/ProductDPP_Edit"));
// const ProductArchive = lazy(() => import("./pages/Products/ProductArchive"));
// const ProductCircularity = lazy(() => import("./pages/Products/ProductCircularity"));
// const ProductCollaborate = lazy(() => import("./pages/Products/ProductCollaborate"));
// const ProductComparison = lazy(() => import("./pages/Products/ProductComparison"));
// const ProductDashboard = lazy(() => import("./pages/Products/ProductDashboard"));
// const ProductEpdDppLibrary = lazy(() => import("./pages/Products/ProductEpdDppLibrary"));
// const ProductPreBuiltTemplate = lazy(() => import("./pages/Products/ProductPreBuiltTemplate"));
// const ProductReuseWorkspace = lazy(() => import("./pages/Products/ProductReuseWorkspace"));
// const ProductWorkspace = lazy(() => import("./pages/Products/ProductWorkspace"));
// const ProfileDashboard = lazy(() => import("./pages/Profile/ProfileDashboard"));
// const ProjectArchive = lazy(() => import("./pages/Projects/ProjectArchive"));
// const ProjectCircularity = lazy(() => import("./pages/Projects/ProjectCircularity"));
// const ProjectComparison = lazy(() => import("./pages/Projects/ProjectComparison"));
// const ProjectDashboard = lazy(() => import("./pages/Projects/ProjectDashboard"));
// const ProjectPreBuiltTemplate = lazy(() => import("./pages/Projects/ProjectPreBuiltTemplate"));
// const ProjectWorkspace = lazy(() => import("./pages/Projects/ProjectWorkspace"));
// const LocalLoading = lazy(() => import("./components/dialog/LocalLoading"));
// const B2B_Directory_Dashboard = lazy(() => import("./pages/B2B_Directory/B2B_Directory_Dashboard"));
// const Client_Directory_Comparison = lazy(() => import("./pages/Client_Directory/Client_Directory_Comparison"));
// const Client_Directory_Dashboard = lazy(() => import("./pages/Client_Directory/Client_Directory_Dashboard"));
// const Client_Directory_My_Submissions = lazy(() => import("./pages/Client_Directory/Client_Directory_MySubmissions"));
// const Client_Directory_Reports = lazy(() => import("./pages/Client_Directory/Client_Directory_Reports"));
// const Client_Directory_SubmitData = lazy(() => import("./pages/Client_Directory/Client_Directory_SubmitData"));
// const Register = lazy(() => import("./pages/Register"));
// const SectorDashboard = lazy(() => import("./pages/Sector/SectorDashboard"));
// const SectorSideBar = lazy(() => import("./pages/Sector/SectorSideBar"));
// const SettingDashboard = lazy(() => import("./pages/Setting/SettingDashboard"));
// const Supplier_Directory_Comparison = lazy(() => import("./pages/Supplier_Directory/Supplier_Directory_Comparison"));
// const Supplier_Directory_Dashboard = lazy(() => import("./pages/Supplier_Directory/Supplier_Directory_Dashboard"));
// const Supplier_Directory_My_Submissions = lazy(() => import("./pages/Supplier_Directory/Supplier_Directory_MySubmissions"));
// const Supplier_Directory_Reports = lazy(() => import("./pages/Supplier_Directory/Supplier_Directory_Reports"));
// const Supplier_Directory_SubmitData = lazy(() => import("./pages/Supplier_Directory/Supplier_Directory_SubmitData"));
// const SupportDashboard = lazy(() => import("./pages/Support/SupportDashboard"));
// const TermsAndConditions = lazy(() => import("./pages/TermsAndConditions"));
// const UsageDashboard = lazy(() => import("./pages/Usage/UsageDashboard"));

const FooterWrapper = () => {
  const location = useLocation();
  const isAuthPage = location.pathname.includes(routing.register) ||
    location.pathname === "/";
  if (isAuthPage) return null;
  return <Footer />;
};

const ArivuBotWrapper = () => {
  const location = useLocation();
  const isPublicDppView = location.pathname.includes(routing.digital_passport.view_published);
  if (isPublicDppView) return null;
  return <ArivuBot />;
};

function App() {
  const sharedRoutes = [
    { path: routing.usage.dashboard, element: <UsageDashboard /> },
    { path: routing.notification.dashboard, element: <NotificationDashboard /> },
    { path: routing.support.dashboard, element: <SupportDashboard /> },
    { path: routing.admin.dashboard, element: <AdminDashboard /> },
    { path: routing.profile.dashboard, element: <ProfileDashboard /> },
    { path: routing.profile.account_settings, element: <UserAccountSettings /> },
    { path: routing.setting.dashboard, element: <SettingDashboard /> },
    { path: routing.logout.root, element: <Logout /> },
  ];
  // Products routes
  const productsRoutes = [
    { path: routing.sector.products.dashboard, element: <ProductDashboard /> },
    { path: routing.sector.products.workspace, element: <ProductWorkspace /> },
    { path: routing.sector.products.reuse_workspace, element: <ProductReuseWorkspace /> },
    { path: routing.sector.products.comparison, element: <ProductComparison /> },
    { path: routing.sector.products.circularity, element: <ProductCircularity /> },
    { path: routing.sector.products.supplier_portal, element: <ProductSupplierPortal /> },
    { path: routing.sector.products.archive, element: <ProductArchive /> },
    { path: routing.sector.products.collaborate, element: <ProductCollaborate /> },
    { path: routing.sector.products.pre_built_template, element: <ProductPreBuiltTemplate /> },
    { path: routing.sector.products.epd_dpp_library, element: <ProductEpdDppLibrary /> },
    { path: routing.sector.products.digital_passport, element: <ProductDPP_Edit /> },
  ];

  // Projects routes
  const projectsRoutes = [
    { path: routing.sector.projects.dashboard, element: <ProjectDashboard /> },
    { path: routing.sector.projects.workspace, element: <ProjectWorkspace /> },
    { path: routing.sector.projects.circularity, element: <ProjectCircularity /> },
    { path: routing.sector.projects.supplier_portal, element: <ProjectSupplierPortal /> },
    { path: routing.sector.projects.archive, element: <ProjectArchive /> },
    { path: routing.sector.projects.pre_built_template, element: <ProjectPreBuiltTemplate /> },
    // {    //   path: "/projects/workspace",
    //   element: <Projects selectedLanguage={selectedLanguage} />,
    // },
    { path: routing.sector.projects.comparison, element: <ProjectComparison /> },
    // {    //   path: "/projects/library",
    //   element: (
    //     <Library selectedLanguage={selectedLanguage} pageType="projects" />
    //   ),
    // },
    { path: routing.sector.projects.digital_passport, element: <ProjectDPP_Edit /> },
  ];

  // Buildings routes
  const buildingsRoutes = [
    // {    //   path: routing.sector.buildings.workspace,
    //   element: <Buildings selectedLanguage={selectedLanguage} />,
    // },

    { path: routing.sector.buildings.comparison, element: <BuildingComparison /> },
    { path: routing.sector.buildings.dashboard, element: <BuildingDashboard /> },
    { path: routing.sector.buildings.archive, element: <BuildingArchive /> },
    { path: routing.sector.buildings.workspace, element: <BuildingWorkspace /> },
    { path: routing.sector.buildings.leed, element: <LEEDTab /> },
    { path: routing.sector.buildings.net_zero, element: <NetZeroTab /> },
    { path: routing.sector.buildings.pre_built_template, element: <BuildingPreBuiltTemplate /> },
    { path: routing.sector.buildings.circularity, element: <BuildingCircularity /> },
    { path: routing.sector.buildings.digital_passport, element: <BuildingDPP_Edit /> },
  ];

  const libraryRoutes = [
    { path: routing.library.archive, element: <Archive /> },
    { path: routing.library.epd, element: <EPD /> },
    { path: routing.library.prebuilt_template, element: <PrebuiltTemplatePage /> },
  ];
  // Organization routes
  const supplyChainRoutes = [
    { path: routing.organization.supply_chain.dashboard, element: <SupplyChainDashboard /> },
    { path: routing.organization.supply_chain.comparison, element: <SupplyChainComparison /> },
    { path: routing.organization.supply_chain.workspace, element: <SupplyChainWorkspace /> },
  ];
  const structureRoutes = [
    { path: routing.organization.structure.dashboard, element: <StructureDashboard /> },
    { path: routing.organization.structure.comparison, element: <StructureComparison /> },
    { path: routing.organization.structure.workspace, element: <StructureWorkspace /> },
  ];
  const corporateRoutes = [
    { path: routing.organization.corporate.dashboard, element: <CorporateDashboard /> },
    { path: routing.organization.corporate.comparison, element: <CorporateComparison /> },
  ];

  // Sustainability Roadmap routes
  const sustainabilityRoutes = [{ path: routing.organization.sustainability.net_zero, element: <NetZero /> }];

  const collaborateRoutes = [
    { path: routing.engagement.collaborate.dashboard, element: <CollaborateDashboard /> },
    { path: routing.engagement.collaborate.digital_data_sharing, element: <CollaborateDigitalDataSharing /> },
    { path: routing.engagement.collaborate.shared_data_history, element: <CollaborateSharedDataHistory /> },
    { path: routing.engagement.collaborate.partnership, element: <CollaboratePartnership /> },
    { path: routing.engagement.collaborate.history, element: <CollaborateSharedLibrary /> },
    { path: routing.engagement.collaborate.my_space, element: <CollaborateMySpace /> },
    { path: routing.engagement.collaborate.internal, element: <CollaborateInternal /> },
    { path: routing.engagement.collaborate.external, element: <CollaborateExternal /> },
  ];
  const organizationComplianceRoutes = [
    { path: routing.organization.compliance.sbti, element: <ComplianceSBTI /> },
    { path: routing.organization.compliance.cdp, element: <ComplianceCDP /> },
    { path: routing.organization.compliance.eco_vadis, element: <ComplianceEcoVadis /> },
  ];
  const sectorComplianceRoutes = [
    { path: routing.sector.compliance.sbti, element: <ComplianceSBTI /> },
    { path: routing.sector.compliance.leed, element: <ComplianceLEED /> },
  ];
  const dppRoutes = [
    { path: routing.digital_passport.dashboard, element: <DPP_Dashboard /> },
    { path: routing.digital_passport.stats, element: <DPP_Stats /> },
    { path: routing.digital_passport.history, element: <DPP_History /> },
    { path: `${routing.digital_passport.view_pending}/:dpp_id`, element: <DPP_View_Pending /> },
    { path: `${routing.digital_passport.edit_pending}/:dpp_id`, element: <DPP_Edit_Pending /> },
  ];
  const dppHostingRoutes = [{ path: `${routing.digital_passport.view_published}/:product_id`, element: <DPP_View_Published /> }];
  const supplierDirectoryRoutes = [
    { path: routing.engagement.supplier_directory.dashboard, element: <Supplier_Directory_Dashboard /> },
    { path: routing.engagement.supplier_directory.my_submissions, element: <Supplier_Directory_My_Submissions /> },
    { path: routing.engagement.supplier_directory.submit_data, element: <Supplier_Directory_SubmitData /> },
    { path: routing.engagement.supplier_directory.comparison, element: <Supplier_Directory_Comparison /> },
    { path: routing.engagement.supplier_directory.reports, element: <Supplier_Directory_Reports /> },
  ];
  const clientDirectoryRoutes = [
    { path: routing.engagement.client_directory.dashboard, element: <Client_Directory_Dashboard /> },
    { path: routing.engagement.client_directory.my_submissions, element: <Client_Directory_My_Submissions /> },
    { path: routing.engagement.client_directory.submit_data, element: <Client_Directory_SubmitData /> },
    { path: routing.engagement.client_directory.comparison, element: <Client_Directory_Comparison /> },
    { path: routing.engagement.client_directory.reports, element: <Client_Directory_Reports /> },
    { path: routing.engagement.client_directory.pending_responses, element: <PendingResponses /> },
  ];
  const B2BDirectoryRoutes = [{ path: routing.engagement.b2b_directory.dashboard, element: <B2B_Directory_Dashboard /> }];
  const sectorRoutes = [
    { path: routing.sector.dashboard, element: <SectorDashboard /> },
    ...productsRoutes,
    ...projectsRoutes,
    ...buildingsRoutes,
    ...dppRoutes,
    ...sectorComplianceRoutes,
  ];
  const organizationRoutes = [
    { path: routing.organization.dashboard, element: <OrganizationDashboard /> },
    ...supplyChainRoutes,
    ...structureRoutes,
    ...corporateRoutes,
    ...organizationComplianceRoutes,
    ...sustainabilityRoutes,
  ];
  const engagementRoutes = [
    { path: routing.engagement.dashboard, element: <EngagementDashboard /> },
    ...collaborateRoutes,
    ...supplierDirectoryRoutes,
    ...clientDirectoryRoutes,
    ...B2BDirectoryRoutes,
  ];
  // Combine all routes
  const commonRoutes = [...sharedRoutes, ...libraryRoutes];

  useEffect(() => {
    const tagManagerArgs = { gtmId: "G-F2RGDH5827" };
    TagManager.initialize(tagManagerArgs);
  }, []);
  return (
    <ThemeProviderWrapper>
      <QueryProvider>
        <BrowserRouter>
          <ScrollToTop />
          <ContextProvider>
            <AuthProvider>
              <PendingUserProvider>
                <Suspense fallback={<LocalLoading />}>
                  <ImpersonationBanner />
                  <Routes>
                    <Route path={routing.login} element={<Login />} />
                    <Route path={routing.register} element={<Register />} />
                    <Route path="/" element={<Navigate replace to={routing.login} />} />
                    <Route path={routing.terms_and_conditions} element={<TermsAndConditions />} />
                    <Route path={`${routing.digital_passport.view_published}/:product_id`} element={<DPP_View_Published />} />
                    <Route path="*" element={<Navigate replace to={routing.home} />} />

                    <Route element={<PrivateRoute />}>
                      <Route element={<SideBar />}>
                        <Route path={routing.home} element={<LandingPage />} />
                        {commonRoutes.map((route, index) => (
                          <Route
                            key={index}
                            path={route.path}
                            element={
                              <Box>
                                <Header />
                                <Box sx={{ display: "flex", minHeight: "calc(100vh - 60px)" }}>
                                  <Box sx={{ flex: 1, minWidth: 0, overflowX: "hidden" }}>{route.element}</Box>
                                  <RightSidebar />
                                </Box>
                              </Box>
                            }
                          />
                        ))}
                      </Route>
                      <Route element={<SectorSideBar />}>
                        {sectorRoutes.map((route, index) => (
                          <Route
                            key={index}
                            path={route.path}
                            element={
                              <Box>
                                <Header />
                                <Box sx={{ display: "flex", minHeight: "calc(100vh - 60px)" }}>
                                  <Box sx={{ flex: 1, minWidth: 0, overflowX: "hidden" }}>{route.element}</Box>
                                  <RightSidebar />
                                </Box>
                              </Box>
                            }
                          />
                        ))}
                      </Route>
                      <Route element={<OrganizationSideBar />}>
                        {organizationRoutes.map((route, index) => (
                          <Route
                            key={index}
                            path={route.path}
                            element={
                              <Box>
                                <Header />
                                <Box sx={{ display: "flex", minHeight: "calc(100vh - 60px)" }}>
                                  <Box sx={{ flex: 1, minWidth: 0, overflowX: "hidden" }}>{route.element}</Box>
                                  <RightSidebar />
                                </Box>
                              </Box>
                            }
                          />
                        ))}
                      </Route>
                      <Route element={<EngagementSideBar />}>
                        {engagementRoutes.map((route, index) => (
                          <Route
                            key={index}
                            path={route.path}
                            element={
                              <Box>
                                <Header />
                                <Box sx={{ display: "flex", minHeight: "calc(100vh - 60px)" }}>
                                  <Box sx={{ flex: 1, minWidth: 0, overflowX: "hidden" }}>{route.element}</Box>
                                  <RightSidebar />
                                </Box>
                              </Box>
                            }
                          />
                        ))}
                      </Route>
                    </Route>
                  </Routes>
                </Suspense>
                <FooterWrapper />
                <ArivuBotWrapper />
              </PendingUserProvider>
            </AuthProvider>
          </ContextProvider>
        </BrowserRouter>
      </QueryProvider>
    </ThemeProviderWrapper>
  );
}

export default App;
